// TODO: remove .filter-item references
import { removeSelectedFit } from '../services/fit.service';
import { scrollTo } from '../helpers/scrollPage';
import Scroll from './Scroll';
import IsMobile from './IsMobile';
const RESET_FIT_SELECTOR = '.bc-sf-filter-clear-all, .bc-sf-filter-option-item[data-parent-label=Size], .bc-sf-filter-option-item[data-parent-label=Fit]';
export default (($) => {
    console.log('UNTUCKit : Module : Filter : loaded');
    const $window = $(window), $body = $('body'), $bindTo = $('.templateCollection');
    let isMobile = false;
    const setPath = function () {
        setURLParams();
    };
    const bindUIActions = function () {
        $bindTo.off('click');
        $window.on('resize', function () {
            if (isMobile && !IsMobile.check(1173)) {
                Scroll.unlock();
                isMobile = false;
            }
            else if (!isMobile && IsMobile.check(1173)) {
                isMobile = true;
            }
        });
        $body.on('click', function () {
            if (!isMobile) {
                $('.toggle-wrap').removeClass('is-active');
            }
        });
        $body.on('click', '.findify-components--custom-facet-item', function () {
            let optionText = $(this).closest('div[class$="__facet"]').find('.findify-components--facet__title span').text();
            if (optionText.length < 1) {
                optionText = $(this).closest('.findify-components--facet__body').parent().find('.findify-components--facet__title span').text();
            }
            window.dataLayer.push({
                'event': 'Findify Filter',
                'filterOption': optionText,
                'filterChoice': $(this).text(),
                'clickType': ($(this).hasClass('selected')) ? 'remove' : 'add'
            });
        });
        $body.on('click', '.findify-components--color-facet__item', function () {
            let optionText = $(this).closest('div[class$="__facet"]').text();
            if (optionText.length < 1) {
                optionText = $(this).closest('.findify-components--facet__body').parent().text();
            }
            window.dataLayer.push({
                'event': 'Findify Filter',
                'filterOption': optionText,
                'filterChoice': $(this).find('span').attr('data-color-name'),
                'clickType': ($(this).hasClass('findify-components--color-facet__active')) ? 'remove' : 'add'
            });
        });
        $bindTo.on('click', '.filter.toggle-target', function (e) {
            e.stopPropagation();
        });
        $bindTo.on('click', '.js-toggle-trigger', function (e) {
            console.log('.js-toggle-trigger clicked');
            const $tar = $(this).parent();
            e.stopPropagation();
            if ($tar.hasClass('is-active')) {
                $tar.removeClass('is-active');
                $(this).attr('aria-expanded', "false");
            }
            else {
                $(this).attr('aria-expanded', "true");
                $tar.addClass('is-active').siblings('.toggle-wrap').removeClass('is-active');
            }
            return false;
        });
        $bindTo.on('click', '.js-toggle-sort', function () {
            $(this).parents('.toggle-wrap').removeClass('is-active');
            Scroll.unlock();
        });
        $bindTo.on('click', '.sort-item', function () {
            const $this = $(this), newText = $this.text();
            window.dataLayer.push({ 'event': 'Sort', 'sortBy': newText });
            $this.parent().prev().trigger('click').find('span:eq(0)').text(newText);
        });
        $bindTo.on('click', '.js-heading', function (e) {
            if (IsMobile.check(1173)) {
                $(this).toggleClass('is-active').next().slideToggle();
                e.stopPropagation();
            }
        });
        $bindTo.on('click', '.js-apply', function () {
            setPath();
            $(this).parents('.toggle-wrap').removeClass('is-active');
            Scroll.unlock();
        });
        $bindTo.on('click', '.js-clear', function () {
            const $scope = $(this).parents('.toggle-target');
            window.dataLayer.push({ 'event': 'Filter Clear' });
            $('.js-remove-filter').remove();
            $scope.parent().removeClass('is-active');
            Scroll.unlock();
        });
        $body.on('click', '.js-hide-filter', handleHideFilter);
    };
    const setURLParams = function (key, value) {
        if (typeof key == 'undefined') {
            history.pushState({ 'title': document.title }, document.title, window.location.href.split('?')[0]);
            return;
        }
        const url = window.location.href, urlConnect = window.location.search == '' ? '?' : '&', newUrl = url + urlConnect + key + '=' + value;
        history.pushState({ 'title': document.title }, document.title, newUrl);
        return;
    };
    function init() {
        console.log('UNTUCKit : Module : Filter : init');
        isMobile = IsMobile.check(1173);
        if ($('.mix-container').length) {
            bindUIActions();
            $('.filter-bar').removeClass('is-disabled');
        }
        if (loadingWithFiltersApplied(window.location.search) && !isSearchPage()) {
            scrollTo(document.querySelector('#collection-results'), focusOnFirstSearchResult);
        }
        $('.filters').on("click", RESET_FIT_SELECTOR, function () {
            removeSelectedFit();
        });
    }
    return {
        init
    };
})($);
function loadingWithFiltersApplied(params) {
    return new URLSearchParams(params).get("_") === "pf";
}
function focusOnFirstSearchResult() {
    const container = document.getElementById('bc-sf-filter-products');
    if (container) {
        const first = container.querySelector('a.img-wrap');
        if (first) {
            first.focus();
        }
    }
}
function isSearchPage() {
    return window.location.href.indexOf('search-results') > -1;
}
function handleHideFilter(e) {
    const text = e.currentTarget.querySelector(".hide-filter__text");
    text.textContent = text.textContent.includes("Hide") ? "Show Filter" : "Hide Filter";
    e.currentTarget.querySelector('.hide-filter__icon').classList.toggle("reverse");
    document.querySelector(".boost-pfs-filter-left-col").classList.toggle("hidden");
    const resultsEl = document.querySelector(".boost-pfs-filter-right-col");
    resultsEl.classList.toggle("full-width");
    const editorialCards = document.querySelectorAll('.editorial-content');
    editorialCards.forEach((e) => e.classList.toggle('editorial-content--large'));
}
